import type { ReferenceUniverseDetails } from "@eu.mdotm.api/sphere";
import { IconWalls } from "$root/components/IconWall";
import { ReactQueryWrapperBase } from "$root/components/ReactQueryWrapper";
import { Text } from "@mdotm/shadcn/legacy/components";
import { universeRepository } from "./repository";

export type SmallUniverseSummaryProps = { universe?: { uuid?: string } };

export function SmallUniverseSummary({ universe: externalUniverse }: SmallUniverseSummaryProps): React.JSX.Element {
	const universeUuid = externalUniverse?.uuid || "";

	const queryUniverseDetails = universeRepository.summary.useQuery(universeUuid);

	return (
		<ReactQueryWrapperBase
			query={queryUniverseDetails}
			errorFallback={
				<div className="bg-white rounded-sm px-2 py-2">
					<IconWalls.ErrorData />
				</div>
			}
		>
			{(universe) => (
				<div className="bg-white rounded-sm px-2 py-2">
					{universe ? (
						<div className="flex items-center gap-4">
							<div>
								<Text type="Body/M/Book">Total instruments</Text>
								&nbsp;
								<Text type="Body/M/Bold">{findRelevantComposition(universe).length}</Text>
							</div>
							<div>
								<Text type="Body/M/Book">Used in</Text>
								&nbsp;
								<Text type="Body/M/Bold">
									{typeof universe.referralInvestments?.length !== "number"
										? "-"
										: universe.referralInvestments.length === 1
										  ? `${universe.referralInvestments.length} portfolio`
										  : `${universe.referralInvestments.length} portfolios`}
								</Text>
							</div>
						</div>
					) : (
						<div className="h-4 flex items-center justify-center">No Data</div>
					)}
				</div>
			)}
		</ReactQueryWrapperBase>
	);
}

const processingStatus = ["RETRIEVING_DATA", "REVIEW"];
function findRelevantComposition(universe: ReferenceUniverseDetails) {
	const { status, universeComposition, uploadComposition } = universe;

	if (!status) {
		return [];
	}

	return (processingStatus.includes(status) ? uploadComposition : universeComposition) ?? [];
}

export type SmallUniverseWithGroupSummaryProps = {
	universe: ReferenceUniverseDetails;
};

export function SmallUniverseWithGroupSummary({ universe }: SmallUniverseWithGroupSummaryProps): React.JSX.Element {
	return (
		<div className="bg-white rounded-sm px-2 py-2">
			{universe ? (
				<div className="flex items-center gap-4">
					<div>
						<Text type="Body/M/Book">Type</Text>
						&nbsp;
						<Text type="Body/M/Bold">Universe with groups</Text>
					</div>
					<div>
						<Text type="Body/M/Book">Unique instruments</Text>
						&nbsp;
						<Text type="Body/M/Bold">{universe.nofInstruments ?? "-"}</Text>
					</div>
					<div>
						<Text type="Body/M/Book">Used in</Text>
						&nbsp;
						<Text type="Body/M/Bold">
							{typeof universe.referralInvestments?.length !== "number"
								? "-"
								: universe.referralInvestments.length === 1
								  ? `${universe.referralInvestments.length} portfolio`
								  : `${universe.referralInvestments.length} portfolios`}
						</Text>
					</div>
				</div>
			) : (
				<div className="h-4 flex items-center justify-center">No Data</div>
			)}
		</div>
	);
}
